import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-between mt-0" }
const _hoisted_2 = {
  key: 0,
  d: "M7.615 11.795l4.59-4.59-1.41-1.41-6 6 6 6 1.41-1.41-4.59-4.59zm9.59 6v-12h-2v12h2z",
  "fill-rule": "evenodd",
  sandboxuid: "0"
}
const _hoisted_3 = {
  key: 1,
  d: "M6 7.41L10.438 12 6 16.59 7.363 18l5.802-6-5.802-6L6 7.41zM16.066 6H18v12h-1.934V6z",
  sandboxuid: "0"
}
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = {
  version: "1.2",
  style: {"overflow":"visible","width":"299px","height":"1px","opacity":"1","mix-blend-mode":"normal"}
}
const _hoisted_7 = { class: "d-flex search-buttons m-auto" }

import SearchFormContent from '@/components/Every24HoursReportPreviewParts/SearchFormContent.vue'; 
import { getDateRangeDays } from '@/services/functions';
import { onMounted, reactive, ref, Ref, computed, watch } from 'vue';
import i18n from '@/lang/i18n';
import '@vuepic/vue-datepicker/dist/main.css';
import { saveDataToSessionStorage, loadDataFromSessionStorage, clearSessionStorage } from "@/services/functions/sessionStorage";
import { getDatetimeWithoutSeconds } from "@/services/functions";

const MAX_FILTER_DAYS = 21;


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchForm',
  props: {
    loading: { type: Boolean, default: false },
    isOperationOffice: { type: Boolean, default: false },
    isSubManagementOffice: { type: Boolean, default: false },
    isManagementOffice: { type: Boolean, default: false },
    isDepartment: { type: Boolean, default: false },
    defaultBackDays: { default: 1 }
  },
  emits: ['search', 'clear'],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const props = __props

let form = reactive({
  managementOffice: undefined,
  operationOffice: undefined,
  group: undefined,
  department: undefined,
  vehicle: undefined,
  driver: undefined,
  selectDateType: 'leaving',
  dateRange: [
    new Date(),
    new Date()
  ] as Date[],
})
const hide: Ref<boolean> = ref(false)
const errors: Ref<{ [key: string]: string[] }> = ref({})


const searchBtnLabel = computed(() => {
  return props.loading ? i18n.global.t('pages.common.button.loading') : i18n.global.t('pages.common.button.exec');
})

const searchAreaClass = computed(() => {
  return hide.value ? 'search-area-hide p-4' : 'search-area p-4';
})

const title = computed(() => {
  return hide.value ? '' : i18n.global.t('pages.common.filter.title');
})

const managementOfficeClearable = computed(() => {
  return props.isManagementOffice;
})

const operationOfficeClearable = computed(() => {
  return props.isManagementOffice || props.isSubManagementOffice;
})

const operationOffices = computed(() => {
  if (form.operationOffice) {
    return [form.operationOffice]
  }
  return null
})

onMounted(() => {
  const savedFormValues = loadDataFromSessionStorage('every24hoursReportSearchForm');
  if (savedFormValues) {
    form.managementOffice = savedFormValues.managementOffice;
    form.operationOffice = savedFormValues.operationOffice;
    form.group = savedFormValues.group;
    form.department = savedFormValues.department;
    form.vehicle = savedFormValues.vehicle;
    form.driver = savedFormValues.driver;
    form.selectDateType = savedFormValues.selectDateType;
    form.dateRange = [new Date(savedFormValues.dateRange[0]), new Date(savedFormValues.dateRange[1])];
  }
})

function handleClickSearch() {
  if (validateForm()) {
    emits('search', form);
    saveDataToSessionStorage('every24hoursReportSearchForm', form);
  }
}

function clearForm() {
  form.managementOffice = managementOfficeClearable.value ? undefined : form.managementOffice
  form.operationOffice = operationOfficeClearable.value ? undefined : form.operationOffice
  form.group = undefined
  form.department = undefined
  form.vehicle = undefined
  form.driver = undefined
  form.selectDateType = 'leaving'
  form.dateRange = [
    new Date(),
    new Date()
  ]
  clearSessionStorage('every24hoursReportSearchForm')
  emits('clear')
}

function toggleSidebar() {
  hide.value = !hide.value;
}

function validateForm() {
  errors.value = {};
  let ret = true;
  if (!form.operationOffice) {
    errors.value['operationOffice'] = [i18n.global.t('pages.common.filter.errorMssages.pleaseSelect')];
    ret = false;
  }
  if (
    !form.dateRange[0] ||
    !form.dateRange[1] ||
    getDatetimeWithoutSeconds(form.dateRange[0]) > getDatetimeWithoutSeconds(form.dateRange[1])
  ) {
    errors.value['end_date'] = [i18n.global.t('pages.common.filter.errorMssages.pleaseSelectCorrectRange')];
    ret = false;
  } else if (
    getDateRangeDays(form.dateRange[0], form.dateRange[1]) > MAX_FILTER_DAYS
  ) {
    errors.value['end_date'] = [
      `${i18n.global.t('pages.common.filter.errorMssages.range')}${MAX_FILTER_DAYS}${i18n.global.t('pages.common.filter.errorMssages.pleaseSelectWithinDays')}`
    ];
    ret = false;
  }
  return ret;
}

function makeInitialForms() {
  const savedFormValues = loadDataFromSessionStorage('every24hoursReportSearchForm');
  if (savedFormValues) {
    return;
  }
  form.dateRange = [new Date(), new Date()];
  if (props.isOperationOffice || props.isDepartment) {
    return form.dateRange[0].setDate(form.dateRange[0].getDate() - props.defaultBackDays);
  }
}

watch(() => props.isOperationOffice, () => {
  makeInitialForms()
})

watch(() => props.isDepartment, () => {
  makeInitialForms()
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(searchAreaClass.value)
  }, [
    _createElementVNode("h4", _hoisted_1, [
      _createTextVNode(_toDisplayString(title.value) + " ", 1),
      (_openBlock(), _createElementBlock("svg", {
        width: "24px",
        height: "24px",
        viewBox: "0 0 24 24",
        fit: "",
        preserveAspectRatio: "xMidYMid meet",
        focusable: "false",
        sandboxuid: "0",
        onClick: toggleSidebar
      }, [
        (hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_2))
          : _createCommentVNode("", true),
        (!hide.value)
          ? (_openBlock(), _createElementBlock("path", _hoisted_3))
          : _createCommentVNode("", true)
      ]))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(`strpied-tabled-with-hover ${hide.value ? 'd-none' : ''}`)
    }, [
      _createVNode(SearchFormContent, {
        modelValue: _unref(form),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(form) ? (form).value = $event : form = $event)),
        errors: errors.value,
        operationOffices: operationOffices.value,
        managementOfficeClearable: managementOfficeClearable.value,
        operationOfficeClearable: operationOfficeClearable.value,
        isDepartment: props.isDepartment,
        maxFilterDays: MAX_FILTER_DAYS
      }, null, 8, ["modelValue", "errors", "operationOffices", "managementOfficeClearable", "operationOfficeClearable", "isDepartment"]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(), _createElementBlock("svg", _hoisted_6, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("defs", null, [
              _createElementVNode("path", {
                id: "path-1650848226989195",
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1),
            _createElementVNode("g", { transform: "translate(-1126, -703)" }, [
              _createElementVNode("path", {
                style: {"stroke":"rgb(194, 186, 186)","stroke-width":"1","stroke-linecap":"butt","stroke-linejoin":"miter","fill":"none"},
                d: "M1126 703 C1126 703 1425 703 1425 703"
              })
            ], -1)
          ]))]))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_btn, {
            class: "mr-5 ma-2 exec-btn",
            onClick: handleClickSearch,
            style: _normalizeStyle({
              backgroundColor: __props.loading ? '#B3B8BB' : '',
            })
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchBtnLabel.value), 1)
            ]),
            _: 1
          }, 8, ["style"]),
          _createVNode(_component_v_btn, {
            class: "ma-2 reset-btn",
            onClick: clearForm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.reset')), 1)
            ]),
            _: 1
          })
        ])
      ])
    ], 2)
  ], 2))
}
}

})